var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileUnfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52259 9.09375C11.351 9.09375 12.9708 7.45324 12.9708 5.25C12.9708 3.04676 11.351 1.40625 9.52259 1.40625C7.69421 1.40625 6.07436 3.04676 6.07436 5.25C6.07436 7.45324 7.69421 9.09375 9.52259 9.09375ZM9.52259 10.5C12.1837 10.5 14.341 8.1495 14.341 5.25C14.341 2.35051 12.1837 0 9.52259 0C6.86147 0 4.70421 2.35051 4.70421 5.25C4.70421 8.1495 6.86147 10.5 9.52259 10.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0280643 19.1138C0.859865 14.3802 5.31884 12 9.49978 12C13.6807 12 18.1396 14.3802 18.9719 19.1137C19.0468 19.5395 18.9741 19.9953 18.728 20.3641C18.4707 20.7498 18.0466 21 17.538 21H1.46152C0.952926 21 0.528964 20.7496 0.271837 20.364C0.0259447 19.9953 -0.0467772 19.5395 0.0280643 19.1138ZM9.49978 13.5C5.7338 13.5 2.12712 15.6198 1.46636 19.38C1.45925 19.4204 1.46065 19.4543 1.46523 19.4789C1.46683 19.4875 1.46871 19.4945 1.47054 19.5H17.5295C17.5313 19.4945 17.5332 19.4874 17.5348 19.4788C17.5394 19.4542 17.5408 19.4205 17.5337 19.3801C16.8725 15.6198 13.2657 13.5 9.49978 13.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUnfilled);
export default __webpack_public_path__ + "static/media/profileUnfilled.ae91da89cb527b54266c6975acd0eadb.svg";
export { ForwardRef as ReactComponent };